import { createAsyncThunk } from "@reduxjs/toolkit";
import sdkProvider from "../../../../client/sdkProvider";
import logger from "../../../../lib/logger";
import commonConfig from "../../../../config/common";
import { showSuccessMessage } from "../../layout/actions";
import getTranslations from "../../../../../i18n";
import { getLocale } from "../selectors";

const {
  globalKeys: { asosKey, eventBusKey },
  myAccountUrl,
} = commonConfig;

const loyaltyOptIn = createAsyncThunk(
  "config/loyaltyOptIn",
  async (_, { dispatch, getState, rejectWithValue }) => {
    try {
      const loyaltySdk = await sdkProvider("loyalty");

      await loyaltySdk.setCustomerConsent("OptedIn");
      const tierId = await loyaltySdk.getCustomerTierId();

      const state = getState();
      const locale = getLocale(state);
      const translations = await getTranslations(locale);

      dispatch(
        showSuccessMessage({
          linkText: translations.new_in_success_message_link,
          linkUrl: `${myAccountUrl}/asos-world`,
          message: translations.new_in_success_message,
        }),
      );

      window[asosKey][eventBusKey].emit("loyaltyStateChange", {
        optedIn: true,
        tierId,
      });

      return tierId;
    } catch (error) {
      error.message = `loyaltyOptIn failed with error: ${error.message}`;
      logger.error(error);

      return rejectWithValue(error);
    }
  },
);

export default loyaltyOptIn;
